import React from 'react';
import classNames from 'classnames';
import get from 'lodash/get';
import { animateScroll as scroll } from 'react-scroll';
import { PAYPAL_THEME, Link } from '@paypalcorp/pp-react';
export default class extends React.Component {
  state = {
    linkClicked: false,
    eventTarget: '',
  };

  handleNavScroll = (navScroll, event) => {
    let refId = navScroll.navId;
    event.preventDefault();
    scroll.scrollTo(document.getElementById(refId).offsetTop - 50);

    let dataSet =
      event.target && event.target.dataset && event.target.dataset.id;
    let dataSetId = dataSet
      ? dataSet
      : this.refs[refId].getAttribute('data-id');

    this.setState({
      linkClicked: true,
      eventTarget: dataSetId, // unique data id to recognize the li element clicked
    });
  };

  renderNavLabel = (navBarTitlePath, index) => {
    let customLabel = get(this.props, navBarTitlePath);
    return customLabel
      ? customLabel
      : this.props.i18n(`label.navLabel${index}`);
  };
  render() {
    let numCharities = this.props.charities ? this.props.charities.length : 0;

    let navScrollLink =
      numCharities > 1
        ? ['groupDonation', 'chooseCharities', 'campaign', 'about']
        : ['campaign', 'about'];
    let navBarTitlePaths =
      numCharities > 1
        ? [
            'templateData.giveToGroupSection.groupDonationNavLabel',
            'templateData.donationModule.navigationTitle1',
            'templateData.aboutSection.navigationTitle2',
            'templateData.ctaSection.navigationTitle3',
          ]
        : [
            'templateData.aboutSection.navigationTitle2',
            'templateData.ctaSection.navigationTitle3',
          ];

    let scroll = navScrollLink.map((navId, index) => {
      let text = `#${navId}`;
      let navListStyling = classNames('scrollLink', {
        nav_link_clicked:
          this.state.linkClicked && this.state.eventTarget === navId, // apply style to the li that is clicked
      });
      let navBarTitlePath = navBarTitlePaths[index];
      return (
        <li key={navId} id={`nemo${navId}`}>
          <Link
            onClick={this.handleNavScroll.bind(this, { navId })}
            ref={navId}
            data-id={navId}
            className={`${navListStyling}`}
            href={text}
            style={{ color: PAYPAL_THEME.sysColorBackgroundMediumContrast }}
          >
            {this.renderNavLabel(navBarTitlePath, index)}
          </Link>
        </li>
      );
    });

    return (
      <nav id='nav_bar' className={this.props.isFixed ? 'navbar-fixed' : ''}>
        <ul className='nav_links'>{scroll}</ul>
      </nav>
    );
  }
}
